import { defineStore } from 'pinia';
import { useRequestStore } from '../views/requests/stores/request_store';
import { usePricesStore } from '../views/prices/stores/prices_store.js';
import {
  Suaje,
  initialFilterSwage,
  Material,
} from '../views/swage/models/swage_model.js';
import api from '@/services/api';
import { getParamsUrl } from '../views/swage/swage_utils.js';

export const useSwageStore = defineStore('swageStore', {
  state: () => ({
    swage: { ...Suaje },
    swageFilters: { ...initialFilterSwage },
    swageUsed: false,
    claseSuaje: [],
    swagesList: [],
    claseSuajeSelected: [],
    page: 1,
    familiaMaterialUsed: { ...Material },
  }),
  actions: {
    normalizePositiveIntValue(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const parsed = Number(value);
      if (Number.isInteger(parsed) && parsed > 0) {
        return parsed;
      }

      return null;
    },
    normalizePositiveNumberValue(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const parsed = Number(value);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }

      return null;
    },
    buildSwagePayload() {
      const payload = JSON.parse(JSON.stringify(this.swage));

      delete payload.CodigoUsuarioCreacion;
      delete payload.FechaCreacion;
      delete payload.CodigoClaseSuaje;
      delete payload.CodigoUsuarioActualizacion;
      delete payload.CotizacionElemento;
      delete payload.FechaActualizacion;
      delete payload.SolicitudElemento;
      delete payload.CodigoTipoCilindro;
      delete payload.MinEtiquetaImpresa;
      delete payload.MinEtiquetaSinImpresion;
      delete payload.MedidaEjeIn;
      delete payload.MedidaDesarrolloIn;

      const minEtiquetaImpresa = this.normalizePositiveIntValue(payload.MinEtiquetaImpresa);
      const minEtiquetaSinImpresion = this.normalizePositiveIntValue(
        payload.MinEtiquetaSinImpresion,
      );
      const medidaEjeIn = this.normalizePositiveNumberValue(payload.MedidaEjeIn);
      const medidaDesarrolloIn = this.normalizePositiveNumberValue(payload.MedidaDesarrolloIn);

      if (minEtiquetaImpresa !== null) {
        payload.MinEtiquetaImpresa = minEtiquetaImpresa;
      }

      if (minEtiquetaSinImpresion !== null) {
        payload.MinEtiquetaSinImpresion = minEtiquetaSinImpresion;
      }

      if (medidaEjeIn !== null) {
        payload.MedidaEjeIn = medidaEjeIn;
      }

      if (medidaDesarrolloIn !== null) {
        payload.MedidaDesarrolloIn = medidaDesarrolloIn;
      }

      return payload;
    },
    setSwageUsed(newValue) {
      this.swageUsed = newValue;
    },
    setFamiliaMaterialUsed(newFamiliaMaterial) {
      this.familiaMaterialUsed = newFamiliaMaterial;
    },
    async resetSwage(useComponent) {
      this.swageUsed = false;
      if (useComponent === 'Solicitud') {
        const requestStore = useRequestStore(); // Crea una instancia del store de request
        await requestStore.resetSwage(structuredClone(Suaje));
      } else if (useComponent === 'Cotizacion') {
        const priceStore = usePricesStore(); // Crea una instancia del store cotizacion
        await priceStore.resetSwage(structuredClone(Suaje));
      }
      // else{
      //   //Logica para cuando se crea un suaje.
      // }
    },
    async resetNewSwage() {
      this.swage = JSON.parse(JSON.stringify(Suaje));
    },
    async findAllClaseSuajeHTTP() {
      this.setPage(1);
      const result = await api.get('/suaje-tipo', { params: { page: +this.page } });
      if (result && result.data) {
        this.claseSuaje.splice(0, this.claseSuaje.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findAClaseSuajeByCodigoHTTP(codigo) {
      try {
        const result = await api.get(`/clase-suaje/${codigo}`);
        if (result && result.data) {
          this.claseSuajeSelected.splice(0, this.claseSuajeSelected.length, result.data);
        }
      } catch (error) {
        console.error('Error en findAClaseSuajeByCodigoHTTP:', error);
      }
    },
    async findAllSuajesHTTP(params) {
      const result = await api.get(
        `/suaje?${getParamsUrl({ page: +this.page, ...this.swageFilters, ...params })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.swagesList.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async firstSwage() {
      this.setPage(1);
      this.emptyList();
      await this.findAllSuajesHTTP();
    },
    async findSuajeByCodigoHTTP(codigo) {
      try {
        const result = await api.get(`/suaje/${codigo}`);
        if (result && result.data) {
          this.swage = { ...Suaje, ...result.data };
        }
      } catch (error) {
        console.error('Error en findSuajeByCodigoHTTP:', error);
      }
    },
    async updateSuajeHTTP() {
      const codigo = this.swage.Codigo;
      const payload = this.buildSwagePayload();
      const response = await api.patch(`/suaje/${codigo}`, payload);
      if (response.status === 200) {
        // Actualizar el store con la respuesta del servidor que incluye los adaptadores
        if (response.data) {
          this.swage = { ...Suaje, ...response.data };
        } else {
          this.resetNewSwage();
        }
        return;
      }
    },
    async newSwageHTTP() {
      const payload = this.buildSwagePayload();
      const response = await api.post('/suaje', payload);
      if (response.status === 200 || response.status === 201) {
        this.resetNewSwage();
        return;
      }
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.swagesList = [];
    },
    resetFilter() {
      this.swageFilters = { ...initialFilterSwage };
    },
    initialNewSwage() {
      this.swage.SuajeMateriaPrimaFamilia = []; // Inicializa con un array vacío
    },
    setFilters(newFilters) {
      this.swageFilters = { ...newFilters };
    },
  },
});
